import React from 'react';

type AnyStatus =
    | 'info'
    | 'pending'
    | 'confirmed'
    | 'warning'
    | 'completed'
    | 'won'
    | 'success'
    | 'canceled'
    | 'failure'
    | 'declined'
    | 'nowinnings'
    | 'played';

type HexColor = `#${string}`;
type Colorset = { [key: HexColor]: AnyStatus[] };
type ColorsetName = 'default' | 'deposits';

type ColoredStatusProps = {
    status: AnyStatus;
    colorset?: ColorsetName;
};

export default function ColoredStatus({ status, colorset = 'default' }: ColoredStatusProps) {
    const style = {
        color: '#2a2a2a',
        backgroundColor: getBackgroundColor(status, colorset),
    };

    return status?.length ? (
        <span style={style} className="px-2 py-1 rounded">
            {status}
        </span>
    ) : null;
}

const COLOR: { [key: PropertyKey]: HexColor } = {
    BLUE: '#7db8ff',
    ORANGE: '#ffca5f',
    GREEN: '#78d366',
    RED: '#ff765b',
};

function getBackgroundColor(status: AnyStatus, colorsetName: ColorsetName): string {
    let colorset: Colorset = {
        [COLOR.ORANGE]: ['pending', 'confirmed', 'warning'],
        [COLOR.RED]: ['canceled', 'failure', 'declined', 'nowinnings'],
        [COLOR.GREEN]: ['completed', 'won', 'success'],
        [COLOR.BLUE]: ['info', 'played'],
    };

    if (colorsetName === 'deposits') {
        colorset = { [COLOR.ORANGE]: ['pending'], [COLOR.GREEN]: ['confirmed'], [COLOR.RED]: ['failure'] };
    }

    return Object.keys(colorset).find((key) => colorset[key].includes(status));
}
